/// <reference path="Navigation.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export abstract class ObjectDataBuilder<T>
			extends SPA.pattern.TabContentBuilder<T>
		{

			public abstract rebuild( root: ui.base.BaseHTMLElement|JQuery, navigation: Navigation ): ObjectDataBuilder<T>;

			public afterBuild(): void {}

			protected constructor( data: T )
			{
				super( data );
			}
		}

	}
}
